import React from 'react'
import PropTypes from 'prop-types'

import { TextField } from 'redux-form-material-ui'

import Icon from '../../../../../components/Icon'

import './styles.css'

function CNPJItem({ onRemove, renderAddButton, hasInputField, input, hintText, fullWidth, meta, ...props }) {

    const _renderStaticView = () => (
        <div 
            className="CNPJItem--static-view"
            {...props}
        >
            {input.value}
            <Icon
                className="CNPJItem__delete-icon"
                name="delete"
                onClick={onRemove}
            />
        </div>
    )

    const _renderInputField = () => (
        <div>
            <TextField
                hintText={hintText}
                fullWidth={fullWidth}
                input={input}
                meta={meta}
                {...props}
            />
            {renderAddButton(meta.invalid, input.value)}
        </div>
    )

    return hasInputField ? _renderInputField() : _renderStaticView()
}

CNPJItem.propTypes = {
    onRemove: PropTypes.func,
    renderAddButton: PropTypes.func,
    hasInputField: PropTypes.bool,
    input: PropTypes.object,
    hintText: PropTypes.string,
    fullWidth: PropTypes.bool,
    meta: PropTypes.object
};

export default CNPJItem